import { isChained, isDateValid, isRequired, normalizeCurrency, normalizeDate, purchasePriceUpperValidator, purchasePriceValidator } from 'core/utilities';
import { FormStep, InputType } from 'view/components/common';
import { Introduction } from './Introduction';

export const formSteps = [
    [
        {
            type : InputType.info,
            Component : Introduction
        }
    ],
    // [
    //     {
    //         type : InputType.choice,
    //         name : 'mortgage_type',
    //         validator: isRequired
    //     }
    // ],
    [
        { 
            type : InputType.location,
            name : 'full_address',
            label : 'Address',
            placeholder : '100 King Street West, Toronto, ON, Canada',
            validator : isRequired
        },
        {
            type : InputType.toggle,
            name : 'offer_made',
            label : 'Have you already made an offer on this property?',
            showTerms : true
        }
    ],
    [
        {
            type : InputType.text,
            name : 'purchase_price',
            label : 'What is the purchase price of the property?',
            placeholder : '$1,234,567',
            validator : isChained([
                isRequired,
                purchasePriceValidator,
                purchasePriceUpperValidator
            ]),
            normalizer : normalizeCurrency
        },
        {
            type : InputType.text,
            name : 'downpayment_amount',
            label : 'How much will your downpayment be?',
            placeholder : '$600,000',
            validator : isRequired,
            normalizer : normalizeCurrency
        },
        {
            type : InputType.select,
            name : 'gift',
            label : 'What are the sources of your downpayment',
            placeholder : 'Less than 1',
            options : [
                { value : false, label : 'Savings' },
                { value : true, label : 'Gift' }
            ]
        },
        {
            type : InputType.text,
            name : 'closing_date',
            label : 'What is your target closing date?',
            placeholder : 'yyyy/mm/dd',
            validator : isChained([
                isRequired,
                isDateValid
            ]),
            normalizer : normalizeDate
        },
    ],
    [
        {
            type : InputType.text,
            name : 'mortgage_value',
            label : 'What is the estimated value of the property?',
            placeholder : '$123,456',
            validator : isRequired,
            normalizer : normalizeCurrency
        },
        {
            type : InputType.text,
            name : 'mortgage_left',
            label : 'How much do you have left on your mortgage?',
            placeholder : '$123,456',
            validator : isRequired,
            normalizer : normalizeCurrency
        },
        {
            type : InputType.text,
            name : 'mortgage_payments',
            label : 'How much are your monthly payments?',
            placeholder : '$123,456',
            validator : isRequired,
            normalizer : normalizeCurrency
        },
        {
            type : InputType.text,
            name : 'mortgage_tax',
            label : 'How much is your property tax?',
            placeholder : '$123,456',
            validator : isRequired,
            normalizer : normalizeCurrency
        },
        {
            type : InputType.text,
            name : 'mortgage_maintenance',
            label : 'How much are your monthly maintenance fees?',
            placeholder : '$123,456',
            validator : isRequired,
            normalizer : normalizeCurrency
        },
    ],
] as Array<FormStep>;
